import { ValidationValueMessage } from 'react-hook-form';
import { IFormField, IFormVariable, ISelect } from '../../types';

const getMaxLength = (value: number | undefined): ValidationValueMessage<number> => {
  const isValueUndefined = value === undefined;
  return {
    value: isValueUndefined ? NaN : value,
    message: isValueUndefined ? '' : `The value must be less than or equal ${value} characters.`,
  };
};

const getMinLength = (value: number | undefined): ValidationValueMessage<number> => {
  const isValueUndefined = value === undefined;
  return {
    value: isValueUndefined ? NaN : value,
    message: isValueUndefined ? '' : `This input must be ${value} characters or more.`,
  };
};

const getMaxValue = (value: number | undefined): ValidationValueMessage<number> => {
  const isValueUndefined = value === undefined;
  return {
    value: isValueUndefined ? NaN : value,
    message: isValueUndefined ? '' : `Value must not be greater than ${value}.`,
  };
};

const getMinValue = (value: number | undefined): ValidationValueMessage<number> => {
  const isValueUndefined = value === undefined;
  return {
    value: isValueUndefined ? NaN : value,
    message: isValueUndefined ? '' : `Value cannot be less than ${value}.`,
  };
};

const parseSelectData = (data: string | undefined): string[] => {
  return data?.replaceAll('-', '').split('\n') ?? [];
};

const getSelectData = (data: string[]): ISelect[] | null => {
  return data.map((el) => ({ value: el, label: el }));
};

const getRequired = (required: boolean): ValidationValueMessage<boolean> => {
  return {
    value: required,
    message: 'Field is required.',
  };
};

const getPattern = (pattern?: string | RegExp, validValue = ''): ValidationValueMessage<RegExp> => {
  const isValueUndefined = pattern === undefined;
  return {
    value: isValueUndefined ? new RegExp(/[\s\S]+/g) : new RegExp(pattern),
    message: `Please enter valid value${validValue && ` (${validValue})`}`,
  };
};

export const prepareInputData = (
  setValue: (name: string, value: string) => void,
  name: string,
  trigger?: (name: string) => void,
  callback?: (value: string) => void,
) => {
  return {
    onChange: (e) => {
      const value = e.currentTarget.value?.trimStart();
      setValue(name, value);
      !!trigger && trigger(name);
      !!callback && callback(value);
    },
    onBlur: (e) => {
      const value = e.currentTarget.value?.trimEnd();
      setValue(name, value);
      !!trigger && trigger(name);
      !!callback && callback(value);
    },
  };
};

export const getFormVariable = (params: Omit<IFormField, 'name' | 'disabled' | 'type' | 'label'>): IFormVariable => {
  const maxLength = getMaxLength(params?.maxLength);
  const minLength = getMinLength(params?.minLength);
  const placeholder = params?.placeholder === undefined ? '' : params.placeholder;
  const url = params?.url === undefined ? '' : params.url;
  const minValue = getMinValue(params?.minValue);
  const maxValue = getMaxValue(params?.maxValue);
  const defaultValue = params?.defaultValue;
  const validateMessage = params?.validationMessage ?? '';
  const required = getRequired(!!params?.required);
  // const valueAsNumber = getValueAsNumber(!!params?.valueAsNumber);
  const pattern = getPattern(params?.pattern, params?.validValue);
  const selectOptions = Array.isArray(params?.options) ?
    params?.options : getSelectData(parseSelectData(params?.options));

  return {
    required,
    maxLength,
    minLength,
    placeholder,
    url,
    minValue,
    maxValue,
    defaultValue,
    validateMessage,
    valueAsNumber: !!params?.valueAsNumber,
    pattern,
    selectOptions,
  };
};
